<div class="w-100 h-100 ov-auto fl fl-dir-c fl-ai-fs fl-jc-fs fl-gap-1">
	@if ($showContent()) {
		<div #contentWrapper class="w-100 fl-fixed pos-sticky pos-t-0" style="z-index: 1">
			<ng-content></ng-content>
		</div>
	}
	<!-- <div class="w-100 fl-adaptable ov-auto fl fl-dir-c fl-ai-fs fl-jc-fs fl-gap-1"> -->
	<!--  -->
	@for (source of $sources(); track source.id) {
		<div
			#sourceCard
			[attr.data-id]="source.id"
			class="w-100 bg-280 br-1h p-2 fl fl-ai-fs fl-jc-fs fl-gap-1"
			[style.scrollMarginTop]="$scrollMargin()"
		>
			<div
				class="w-sp-2 h-sp-2 fl-fixed br-circle fc-white fl fl-ai-c fl-jc-c fs-xs"
				style="background-color: var(--color-line-330)"
			>
				{{ source.inlineNumber }}
			</div>

			<div class="fl-adaptable">
				{{ source.content }}
			</div>
		</div>
	}
	<!-- </div> -->
</div>
